import { useState, useEffect } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

const BUYER_INCENTIVES_V3_RESP = 'EnhancedBuyerIncentivesTextSRandHPDESK';
const BUYER_INCENTIVES_V3_MOBILE = 'EnhancedBuyerIncentivesTextSRandHPMW';

type Variant = 'variant-a' | 'variant-b';

const ifVariant = ({ isMobile, variant }: { isMobile: boolean; variant: Variant }): boolean =>
    getAbTestV2(isMobile ? BUYER_INCENTIVES_V3_MOBILE : BUYER_INCENTIVES_V3_RESP)?.variant ===
    variant;

export const useBuyerIncentivesV3ClientVariant = ({
    isMobile,
    variant,
}: {
    isMobile: boolean;
    variant: Variant;
}): boolean | null => {
    const [isVariant, setIsVariant] = useState<boolean | null>(null);

    useEffect(() => {
        setIsVariant(ifVariant({ isMobile, variant }));
    }, [isMobile, variant]);

    return isVariant;
};

export const useBuyerIncentivesV3ClientVariants = ({
    isMobile,
}: {
    isMobile: boolean;
}): boolean | null => {
    const isVariantA = useBuyerIncentivesV3ClientVariant({ isMobile, variant: 'variant-a' });
    const isVariantB = useBuyerIncentivesV3ClientVariant({ isMobile, variant: 'variant-b' });

    return isVariantA || isVariantB;
};

export const useTrackBuyerIncentivesV3 = ({ isMobile }: { isMobile: boolean }): void => {
    useEffect(() => {
        trackAbTestV2Variant(isMobile ? BUYER_INCENTIVES_V3_MOBILE : BUYER_INCENTIVES_V3_RESP);
    }, [isMobile]);
};
